import CgJobDescription from "../../component/job_registration/cg_job_description";
import NurseJobDescription from "../../component/job_registration/nurse_job_description";
import PhysioJobDescription from "../../component/job_registration/physio_job_description";

const JobDescription = ({role}) => {
    return (
        role == "caregiver" ? <CgJobDescription /> : 
        role == "nurse" ? <NurseJobDescription /> :
        role == "physiotherapy" ? <PhysioJobDescription /> : <></>
    );
}

export default JobDescription;